import React from "react";
import Reveal from "@/components/Reveal";

const STATS = [
  { value: "30+", label: "Lat doświadczenia" },
  { value: "2 000+", label: "Zrealizowanych zleceń" },
  { value: "CNC", label: "Nowoczesny park maszynowy" },
  { value: "100%", label: "Indywidualnych projektów" },
];

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1604011237320-8b9a3a8d8f44?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function About() {
  return (
    <section id="o-nas" data-testid="about-section" className="relative py-24 md:py-36 bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <p className="overline mb-6">O nas</p>
          <h2 className="section-title text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            Rzemiosło, które
            <br />
            <span className="italic text-neutral-300">przetrwa pokolenia</span>.
          </h2>

          <div className="mt-10 space-y-5 text-neutral-300 leading-relaxed">
            <p>
              <span className="text-white font-medium">Kamieniarstwo Mrozek</span> to rodzinna
              firma z wieloletnim doświadczeniem w obróbce granitu, marmuru i konglomeratów. Od
              pierwszego pomiaru, przez projekt, aż po profesjonalny montaż — każdy etap nadzorujemy
              osobiście.
            </p>
            <p>
              Nasz nowoczesny park maszynowy z technologią CNC pozwala realizować nawet
              najbardziej skomplikowane formy z najwyższą precyzją. Stawiamy na indywidualne
              podejście, terminowość i fachowe doradztwie na każdym kroku.
            </p>
            <p>
              Łączymy klasyczne, ręczne rzemiosło z nowoczesnymi technologiami — efekt to obiekty,
              które zachwycają detalem i trwają dziesięciolecia.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-px bg-neutral-800">
            {STATS.map((s, i) => (
              <div
                key={i}
                data-testid={`about-stat-${i}`}
                className="bg-[#050505] p-6 md:p-8"
              >
                <p className="font-serif-display text-white text-3xl md:text-4xl">{s.value}</p>
                <p className="mt-2 text-[11px] uppercase tracking-[0.25em] text-neutral-400">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={150} className="lg:col-span-7 relative">
          <div className="relative w-full aspect-[4/5] hairline overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Pracownia kamieniarska Mrozek"
              className="w-full h-full object-cover grayscale-[35%] hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10 border-t border-white/10 bg-black/30 backdrop-blur-sm">
              <p className="overline mb-2 text-neutral-300">Filozofia pracy</p>
              <p className="font-serif-display text-2xl md:text-3xl text-white leading-tight">
                {`„Kamień nie znosi pośpiechu — wymaga uwagi, cierpliwości i precyzji."`}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
